import { render, staticRenderFns } from "./SalesOrderPick.vue?vue&type=template&id=6722cb34&scoped=true&"
import script from "./SalesOrderPick.vue?vue&type=script&lang=js&"
export * from "./SalesOrderPick.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderPick.vue?vue&type=style&index=0&id=6722cb34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6722cb34",
  null
  
)

export default component.exports